let isRedirectInProgress = false;

/**
 * One-shot guard for external redirects (full document navigations).
 *
 * Safari/WebKit cancels in-flight fetches the moment a navigation starts, while the
 * current document is still running JS. A rejected fetch can then trigger a second,
 * competing redirect (e.g. WorkspaceInit's workspace-info .catch()) that replaces the
 * pending navigation (T20-133450). The first external redirect must win; later ones no-op.
 */
export const isExternalNavigationClaimed = () => isRedirectInProgress;

export const navigateExternally = (url: string | (() => Promise<string>)) => {
  if (isRedirectInProgress) {
    return;
  }

  isRedirectInProgress = true;
  if (typeof url === 'string') {
    window.location.href = url;
    return;
  }

  return url()
    .then((destination) => {
      window.location.href = destination;
    })
    .catch((error: Error) => {
      isRedirectInProgress = false;
      throw error;
    });
};

/**
 * Test-only reset — module state would otherwise leak between test cases.
 */
export const resetNavigateExternallyGuard = () => {
  isRedirectInProgress = false;
};

// Safari restores pages from the back/forward cache with module state intact.
// A stale guard would silently swallow every future redirect on the restored page.
window.addEventListener('pageshow', (event) => {
  if (event.persisted) {
    isRedirectInProgress = false;
  }
});
